var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_eth_50px",
    transform: "translate(-456 -1349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_54",
    "data-name": "\\uD0C0\\uC6D0 54",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(456 1349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "img_erc20",
    transform: "translate(471.385 1360.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_211",
    "data-name": "\\uD328\\uC2A4 211",
    d: "M464.038,315.477V322.7l8.866-12.453Z",
    transform: "translate(-455.173 -293.854)",
    fill: "#232423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_212",
    "data-name": "\\uD328\\uC2A4 212",
    d: "M464.038,219.982v9.27l8.866-5.244Z",
    transform: "translate(-455.173 -209.3)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_213",
    "data-name": "\\uD328\\uC2A4 213",
    d: "M464.038,51.13V61.813l8.866,4.026Z",
    transform: "translate(-455.173 -51.13)",
    fill: "#232423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_214",
    "data-name": "\\uD328\\uC2A4 214",
    d: "M332.774,315.477V322.7l-8.866-12.453Z",
    transform: "translate(-323.908 -293.854)",
    fill: "#6f7071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_215",
    "data-name": "\\uD328\\uC2A4 215",
    d: "M332.777,219.982v9.27l-8.866-5.244Z",
    transform: "translate(-323.911 -209.3)",
    fill: "#272828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_216",
    "data-name": "\\uD328\\uC2A4 216",
    d: "M332.777,51.13V61.813l-8.866,4.026Z",
    transform: "translate(-323.911 -51.13)",
    fill: "#6f7071"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.f31173e0.svg";
export { ForwardRef as ReactComponent };